export function deleteCookie(name: string) {
  // Delete for current domain
  document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  
  // Delete for production domain
  if (process.env.NODE_ENV === "production") {
    document.cookie = `${name}=; path=/; domain=.drdaviddanish.com; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  }
  
  console.log(`🍪 Cookie "${name}" deleted`);
}